import { useAppSelector } from "@/shared/lib/redux"
import { selectLatestUsers } from "../../model"
import UserSvg from '@/shared/assets/images/User.svg'
import SealSvg from '@/shared/assets/images/SealCheck.svg'
import { Link } from "react-router-dom"
import { getDisplayName } from "@/entities/user"

export const LatestUsersList = () => {
    const latestUsers = useAppSelector(selectLatestUsers)
    return (
        <div className="box h-full">
            <div className="box_header !mb-0">
                Последние пользователи
            </div>
            <div className="flex flex-col max-h-[400px] overflow-auto">
                {latestUsers.map((user) => 
                    <div 
                        key={user.id}
                        className='flex items-center px-2 py-4 border-b border-[#ccc]'
                    >
                        <div className="w-8 h-8 bg-color-dark text-white flex items-center justify-center rounded-full">
                            <UserSvg width={18} height={18} />
                        </div>
                        <div className="ml-2 gap-[2px] flex flex-col">
                            <Link to={`/users/profile/${user.id}`} className="text-base hover:cursor-pointer hover:underline font-normal">
                                {getDisplayName(user)}
                            </Link>
                            <div className="flex items-center">
                                <div className="text-[#828282] text-[13px]">
                                    Новый пользователь
                                </div>
                                <div className="text-color-primary ml-[6px]">
                                    <SealSvg width={18} height={18} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}